export const tabs = {
    slots: {
        root: 'flex items-center gap-2',
        list: 'relative flex group overflow-x-auto overflow-y-hidden border-b',
        indicator: 'absolute transition-[translate,width] duration-200',
        trigger: [
            'group relative inline-flex items-center shrink-0 min-w-0 data-[state=inactive]:text-(--ui-text-muted) hover:data-[state=inactive]:not-disabled:text-(--ui-text) font-medium rounded-[calc(var(--ui-radius)*1.5)] disabled:cursor-not-allowed disabled:opacity-75 focus:outline-hidden',
            'transition-colors',
        ],
        content: 'focus:outline-none w-full',
        leadingIcon: 'shrink-0',
        leadingAvatar: 'shrink-0',
        leadingAvatarSize: '',
        label: 'truncate',
    },
    variants: {
        color: {
            primary: '',
            secondary: '',
            success: '',
            info: '',
            warning: '',
            error: '',
            neutral: '',
        },
        variant: {
            pill: {
                list:
                    'bg-(--ui-bg-elevated) rounded-[calc(var(--ui-radius)*2)]',
                trigger: 'flex-1 w-full',
                indicator: 'rounded-[calc(var(--ui-radius)*1.5)] shadow-xs',
            },
            soft: {
                list: 'bg-transparent',
                trigger: 'flex',
                indicator: 'rounded-[calc(var(--ui-radius)*1.5)] shadow-xs',
            },
            link: {
                list: 'border-(--ui-border)',
                indicator: 'rounded-full',
            },
        },
        orientation: {
            horizontal: {
                root: 'flex-col',
                list: 'w-full',
                indicator:
                    'left-0 w-(--reka-tabs-indicator-size) translate-x-(--reka-tabs-indicator-position)',
                trigger: 'justify-center',
            },
            vertical: {
                list: 'flex-col',
                indicator:
                    'top-0 h-(--reka-tabs-indicator-size) translate-y-(--reka-tabs-indicator-position)',
            },
        },
        size: {
            xs: {
                trigger: 'px-2 py-1 text-xs gap-1',
                leadingIcon: 'size-4',
                leadingAvatarSize: '3xs',
            },
            sm: {
                trigger: 'px-2.5 py-1.5 text-xs gap-1.5',
                leadingIcon: 'size-4',
                leadingAvatarSize: '3xs',
            },
            md: {
                trigger: 'px-3 py-1.5 text-sm gap-1.5',
                leadingIcon: 'size-5',
                leadingAvatarSize: '2xs',
            },
            lg: {
                trigger: 'px-3 py-2 text-sm gap-2',
                leadingIcon: 'size-5',
                leadingAvatarSize: '2xs',
            },
            xl: {
                trigger: 'px-3 py-2 text-base gap-2',
                leadingIcon: 'size-6',
                leadingAvatarSize: 'xs',
            },
        },
    },
    compoundVariants: [
        {
            orientation: 'horizontal',
            variant: 'pill',
            class: {
                indicator: 'inset-y-1',
            },
        },
        {
            orientation: 'horizontal',
            variant: 'soft',
            class: {
                list: 'relative flex border-b px-0 mx-0',
                indicator: '-bottom-px h-px',
                trigger:
                    '-mb-1 data-[state=active]:bg-neutral-100 data-[state=active]:dark:bg-neutral-800 data-[state=active]:border-t border-(--ui-border) data-[state=active]:border-l data-[state=active]:border-r data-[state=active]:rounded-t-0 data-[state=active]:rounded-b-none',
            },
        },
        {
            orientation: 'horizontal',
            variant: 'link',
            class: {
                list: 'border-b -mb-px',
                indicator: '-bottom-px h-px',
            },
        },
        {
            orientation: 'vertical',
            variant: 'pill',
            class: {
                indicator: 'inset-x-1',
                list: 'items-center',
            },
        },
        {
            orientation: 'vertical',
            variant: 'link',
            class: {
                list: 'border-s -ms-px',
                indicator: '-start-px w-px',
            },
        },
        {
            color: 'primary',
            variant: 'pill',
            class: {
                indicator: 'bg-(--ui-primary)',
                trigger:
                    'data-[state=active]:text-(--ui-bg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-primary)',
            },
        },
        {
            color: 'neutral',
            variant: 'pill',
            class: {
                indicator: 'bg-(--ui-bg-inverted)',
                trigger:
                    'data-[state=active]:text-(--ui-bg) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-border-inverted)',
            },
        },
        {
            color: 'primary',
            variant: 'link',
            class: {
                indicator: 'bg-(--ui-primary)',
                trigger:
                    'data-[state=active]:text-(--ui-primary) focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-primary)',
            },
        },
        {
            color: 'neutral',
            variant: 'link',
            class: {
                indicator: 'bg-(--ui-bg-inverted)',
                trigger:
                    'data-[state=active]:text-(--ui-text-highlighted) focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-(--ui-border-inverted)',
            },
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'pill',
        size: 'md',
    },
}
